._content_1sutk_1 {
  margin: 12px; }

._container_1sutk_4 {
  margin: 24px 0 24px 24px; }
